import API from '@/axios'

const EndpointRecipients = 'models/recipients'

export default {
	async getRecipients(params = {}) {
		const queryParams = new URLSearchParams()

		if (params.page) queryParams.append('page', params.page)
		if (params.perPage) queryParams.append('limit', params.perPage)
		if (params.search) queryParams.append('search', params.search)

		const url = queryParams.toString()
			? `${EndpointRecipients}?${queryParams.toString()}`
			: EndpointRecipients

		return await API.get(url).then((response) => response)
	},

	async createRecipient(payload) {
		return await API.post(EndpointRecipients, payload).then((response) => response)
	},

	async updateRecipient(payload, id) {
		return await API.put(`${EndpointRecipients}/${id}`, payload).then((response) => response)
	},

	async deleteRecipient(id) {
		return await API.delete(`${EndpointRecipients}/${id}`).then((response) => response)
	},
}
